import { clsx, type ClassValue } from 'clsx';

/** Merge class names; call-site spacing stays outside components. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
